export function audioCommentsPagePath(
  trackId: string,
  fileId: string,
  options?: { selectedComment?: string },
): string {
  const params = new URLSearchParams();
  if (options?.selectedComment) {
    params.set('selectedComment', options.selectedComment);
  }

  const encodedTrack = encodeURIComponent(trackId);

  if (fileId.includes('/')) {
    params.set('fileId', fileId);
    const qs = params.toString();
    return `/tracks/${encodedTrack}/audio/comments${qs ? `?${qs}` : ''}`;
  }

  const encodedFile = encodeURIComponent(fileId);
  const qs = params.toString();
  return `/tracks/${encodedTrack}/audio/${encodedFile}/comments${qs ? `?${qs}` : ''}`;
}

export function isAudioCommentsPagePath(pathname: string): boolean {
  return /^\/tracks\/[^/]+\/audio\/(?:[^/]+\/comments|comments(?:\?|$))/.test(pathname);
}

export function trackIdFromAudioCommentsPath(pathname: string): string | null {
  const match = pathname.match(/^\/tracks\/([^/]+)\/audio\//);
  return match?.[1] ?? null;
}
